module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABPUlEQVRYR+2XO04DMRCGv3FoOQNZcQFElUdDR8tJEEKiAXmR1koRQQv3oKQiTR4VDTXa5Aw0FOBBmwCiSIizQEyx21kaz//5H89qLET+JLI+krjmHcheHBDtSeJaGkd8pvoJkNvBWsvxcfAKoHLg/zvw0zZd1F3BXRAd4K9+UsEOVADRHYh+CaMDRC9BBVA5sDYHlgoJN97TnaSD4Xex9U5rx3jOFQ6W5pwNpSuN5V7R7tgOT+clr2fNIzFyiVILEQftBU/CiWtb0BTYAB4Ufzi2o14hVJwaz5VAC3gByXLbdyEQwQBFsu2s0fYYi7A/Ta5cY3hGOX5f3xq8e0xH/RDx6bsgNPBrXOLaJ4halM3Z64InVFxu+xer5isFUIhsdRq75tUUJcHXfDY5G92vKl7agTJCi/aUduC3IN4AF/PRVxRoqgQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/xx1.png
// module id = 9bzr
// module chunks = 3